import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";

import pathnames from "routes/pathnames";
import { updateProfile } from "store/slices/profile-slice";

import api from "services/api";

import serveRequestErrors from "common/serve-request-errors";

import REGEX from "constants/regex";
import ERRORS from "constants/errors";
import CONSTANTS from "constants/constant";

import PageLoginDto from "dto/pages/authenticate/page-login-dto-";

import AppAlert from "components/app-alert";
import AppInput from "components/app-input";
import AppButton from "components/app-button";
import AppAuthLayout from "components/pages/page-authenticate/app-auth-layout";

import logoIcon from "assets/images/components/app-side-nav/logo-atf.svg";

const PageLogin = () => {
	const navigate = useNavigate();

	const dispatch = useDispatch();

	const showForgotPassword = false;

	const formik = useFormik<PageLoginDto>({
		initialValues: { email: "", password: "" },
		validationSchema: yup.object({
			email: yup.string().matches(REGEX.EMAIL, ERRORS.EMAIL).required(ERRORS.REQUIRED),
			password: yup.string().required(ERRORS.REQUIRED),
		}),
		onSubmit: (values) => {
			onHandleSubmit(values);
		},
	});

	//prettier-ignore
	const onHandleSubmit = useCallback(async (values: PageLoginDto) => {
        
        let response = null;

        try {
            const payload = {
                email: values.email,
                password: values.password,
            };

            response = await api.post.authenticate.login(payload);
        } catch (error: any) {
            serveRequestErrors(JSON.parse(error.response?.data?.message)?.message || error);

            formik.setSubmitting(false);
        }

        if (response) {
			const profileData = {
				customerId:response.data.data.customerId,
				email:response.data.data.email
			}
			
			dispatch(updateProfile(profileData))
			
            sessionStorage.setItem(CONSTANTS.API_KEY, response.data.data.apiToken);

            navigate(pathnames.solutions);
        }
        

    }, [formik, dispatch, navigate]);

	const onHandleForgotPassword = () => {
		navigate(pathnames.forgotPassword);
	};

	return (
		<AppAuthLayout>
			<div className="page-login">
				<div className="login">
					<AppAlert />

					<form className="login__form" onSubmit={formik.handleSubmit}>
						<img className="login__logo" src={logoIcon} alt="company-logo" />

						<h1 className="login__title">Welcome Back!</h1>

						<p className="login__description">Web Content Management System</p>

						<AppInput type="text" name="email" placeholder="Username or Email Address" value={formik.values.email} error={formik.errors.email} touched={formik.touched.email} onChange={formik.handleChange} />

						{/* prettier-ignore */}
						<AppInput type="password" name="password" placeholder="Password" autoComplete="on" value={formik.values.password} error={formik.errors.password} touched={formik.touched.password} onChange={formik.handleChange} />

						{showForgotPassword && (
							<div className="login__forgot-password-container">
								{/* prettier-ignore */}
								<p className="login__forgot-password-link" onClick={onHandleForgotPassword}>Forgot Password?</p>
							</div>
						)}

						<div className="login__button-container">
							<AppButton type="submit" label="Login" disabled={formik.isSubmitting} large smallRadius />
						</div>
					</form>
				</div>
			</div>
		</AppAuthLayout>
	);
};

export default PageLogin;
